// src/components/CreditsPopup.jsx
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function CreditsPopup({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // Gestione overflow body e tasto Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Credits"
    >
      <div
        className="relative w-full max-w-4xl bg-white shadow-2xl rounded-xl max-h-[90vh] overflow-y-auto"
        style={{ background: "linear-gradient(135deg, #F1F7FD 0%, #E7F1FA 100%)" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Pulsante di chiusura */}
        <div className="sticky top-3 z-10 flex justify-end pr-3">
          <button
            type="button"
            onClick={() => onClose?.()}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            aria-label="Chiudi"
          >
            <span className="text-[#0E3761] text-xl leading-none">×</span>
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-6 md:p-10 -mt-6">
          <h3 className="text-[#0E3761] text-[24px] md:text-[32px] font-bold mb-4">Credits e contatti</h3>

          <p className="text-[#0E3761] text-[20px] md:text-[24px] mb-3">
            Redazione del Bilancio Consolidato Integrato 2025:
          </p>

          <ul className="list-disc pl-6 mb-4 text-[#0E3761] text-[20px] md:text-[24px] space-y-1 font-bold">
            <li>
              Consolidated Financial Statements and Solvency II
            </li>
            <li>
              Group Sustainability
            </li>
          </ul>

          <p className="text-[#0E3761] text-[20px] md:text-[24px] mb-6">
            <a
              href="mailto:bilanciointegrato@realegroup.eu"
              className="underline hover:text-[#004996] font-normal"
            >
              bilanciointegrato@realegroup.eu
            </a>
          </p>

          <p className="text-[#0E3761] text-[20px] md:text-[24px] mb-6 font-bold">
            Group Sustainability
            <br/>
            <a
              href="mailto:direzionesostenibilitadigruppo@realemutua.it"
              className="underline hover:text-[#004996] font-normal"
            >
              direzionesostenibilitadigruppo@realemutua.it
            </a>
          </p>

          <p className="text-[#0E3761] text-[20px] md:text-[24px] mb-6 font-bold">
            Ufficio Stampa
            <br/>
            <a
              href="mailto:ufficiostampa@realegroup.eu"
              className="underline hover:text-[#004996] font-normal"
            >
              ufficiostampa@realegroup.eu
            </a>
          </p>

          <p className="text-[#0E3761] text-[20px] md:text-[24px]">
            <b>Progetto creativo ed editoriale</b><br/>MGP // Mercurio GP
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}